<template>
  <div class="vip-settings">
    <div class="c-table-wrapper">
      <div v-if="allWebsites !== null" class="add-button">
        <div class="add-section">
          <div class="c-search">
            <md-field class="u-width-m u-mb-xs u-mr-md">
              <label>Search</label>
              <md-input v-model="searchQuery" />
            </md-field>
          </div>
        </div>
      </div>

      <base-table-component 
        v-if="allWebsites !== null && filteredWebsites.length" 
        :prop-data="filteredWebsites" 
        action-label="VIP Pages"
      >
        <template v-slot:default="slotProps">
          <template>
            <span class="c-table__btn-wrap">
              <button
                type="button"
                class="ui-btn ui-btn--secondary ui-btn--sm"
                @click="openVipPages(slotProps.selected)"
              >
                Pages
                <app-icon
                  name="chevron_right"
                  :size="18"
                />
              </button>
              <button
                type="button"
                class="ui-btn ui-btn--secondary ui-btn--sm"
                @click="openAssets(slotProps.selected)"
              >
                Assets
                <app-icon
                  name="chevron_right"
                  :size="18"
                />
              </button>
            </span>
          </template>
        </template>
      </base-table-component>

      <template v-if="allWebsites !== null && !filteredWebsites.length">
        <div class="l-empty-container u-full-height">
          <md-empty-state
            md-icon="announcement"
            md-label="No Data"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BaseTableComponent from '@/shared/table/BaseTableComponent';
import AppIcon from "@/shared/app-icon/AppIcon";
import {websiteService} from "@/services/websites";
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";

export default {
  name: "VipSettingsComponent",

  components: {
    BaseTableComponent,
    AppIcon,
  },

  mixins: [onlinePermissionsMixin],

  data() {
    return {
      searchQuery: '',
      allWebsites: null,
      selectedWebsite: null,
    };
  },

  computed: {
    filteredWebsites() {
      return this.formatWebsitesTableData(this.searchQuery ? this.allWebsites.filter(website => { return website.name.includes(this.searchQuery) }) : this.allWebsites);
    },
  },

  async created() {
    await this.getWebsites();
  },

  methods: {
    async getWebsites() {
      const response = await websiteService.getWebsites();
      this.allWebsites = response.data.filter((website) => this.canReadWebsite(website.id)) || [];
    },

    formatWebsitesTableData(websites) {
      const formattedWebsites = [];

      websites.forEach(website => {
        formattedWebsites.push({
          website: website,
          rowData: {
            'Name': website.name,
            'Id': website.id,
          }
        });
      });

      return formattedWebsites;
    },

    openVipPages(selected) {
      this.selectedWebsite = selected.website;
      this.$router.push({
        name: 'on-line-vip-pages-list',
        params: { 
          websiteId: selected.website.id,
        }
      });
    },

    openAssets(selected) {
      this.$router.push({
        name: 'on-line-vip-assets',
        params: {
          websiteId: selected.website.id,
        }
      });
    },
  },
};
</script>
